const ripple = "absolute pointer-events-none rounded-full bg-current opacity-20";

const loadingWrapper = "absolute inset-0 flex items-center justify-center";

const iconLeft = "mr-2";

const iconRight = "ml-2";

export { ripple, loadingWrapper, iconLeft, iconRight };
